import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BannersAdmin } from "@/components/BannersAdmin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELDS = [
  { key: "price_display", label: "Preço exibido", placeholder: "R$ 19,90", testId: "admin-input-preco" },
  { key: "checkout_url", label: "URL do checkout (Monetizze)", placeholder: "https://pay.monetizze.com.br/...", testId: "admin-input-checkout" },
  { key: "cover_url", label: "URL da capa do e-book (deixe vazio para usar a capa padrão)", placeholder: "https://...", testId: "admin-input-capa" },
  { key: "support_contact", label: "Contato de suporte", placeholder: "seuemail@exemplo.com", testId: "admin-input-contato" },
  { key: "meta_pixel_id", label: "Meta Pixel ID", placeholder: "Em branco = desativado", testId: "admin-input-pixel" },
  { key: "google_ads_id", label: "Google Ads ID (AW-...)", placeholder: "Em branco = desativado", testId: "admin-input-ads" },
];

export default function Admin() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings`).then((res) => setForm(res.data)).catch(() => {
      toast.error("Não foi possível carregar as configurações.");
    });
  }, []);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/settings`, form);
      setForm(data);
      toast.success("Configurações salvas com sucesso.");
    } catch {
      toast.error("Erro ao salvar. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  if (!form) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-obsidian">
        <p className="font-serif text-creme/70">Carregando...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-obsidian px-5 py-16 text-creme" data-testid="admin-page">
      <div className="mx-auto max-w-2xl">
        <div className="flex items-center gap-3">
          <svg viewBox="0 0 64 64" className="h-8 w-8" aria-hidden="true">
            <path d="M42 8a26 26 0 1 0 12 40A30 30 0 0 1 42 8z" fill="none" stroke="#D6AF62" strokeWidth="3" />
            <circle cx="46" cy="16" r="2" fill="#D6AF62" />
          </svg>
          <h1 className="font-cinzel text-xl tracking-[0.25em] text-dourado">PAINEL · MEU EX DE VOLTA</h1>
        </div>
        <p className="mt-3 text-sm text-creme/60">
          Configure o preço, o checkout, a capa, os textos comerciais e o rastreamento da landing page.
        </p>

        <form onSubmit={save} className="mt-10 space-y-6" data-testid="admin-form">
          {FIELDS.map((f) => (
            <div key={f.key}>
              <label htmlFor={f.key} className="mb-2 block text-xs font-semibold uppercase tracking-[0.2em] text-rosa">
                {f.label}
              </label>
              <input
                id={f.key}
                data-testid={f.testId}
                value={form[f.key] || ""}
                onChange={set(f.key)}
                placeholder={f.placeholder}
                className="w-full rounded-lg border border-dourado/25 bg-carddark px-4 py-3 text-sm text-creme placeholder:text-creme/30 focus:border-dourado focus:outline-none"
              />
            </div>
          ))}

          <div>
            <label htmlFor="offer_heading" className="mb-2 block text-xs font-semibold uppercase tracking-[0.2em] text-rosa">
              Título da oferta (seção de decisão)
            </label>
            <textarea
              id="offer_heading"
              data-testid="admin-input-oferta-titulo"
              value={form.offer_heading || ""}
              onChange={set("offer_heading")}
              rows={3}
              className="w-full rounded-lg border border-dourado/25 bg-carddark px-4 py-3 text-sm text-creme focus:border-dourado focus:outline-none"
            />
          </div>
          <div>
            <label htmlFor="offer_text" className="mb-2 block text-xs font-semibold uppercase tracking-[0.2em] text-rosa">
              Texto da oferta (seção de decisão)
            </label>
            <textarea
              id="offer_text"
              data-testid="admin-input-oferta-texto"
              value={form.offer_text || ""}
              onChange={set("offer_text")}
              rows={5}
              className="w-full rounded-lg border border-dourado/25 bg-carddark px-4 py-3 text-sm text-creme focus:border-dourado focus:outline-none"
            />
          </div>

          <button
            type="submit"
            data-testid="admin-save-button"
            disabled={saving}
            className="w-full rounded-full bg-gradient-to-r from-[#A47B2C] via-dourado to-[#F3E5C8] py-4 text-sm font-bold uppercase tracking-[0.15em] text-vinho transition-transform duration-300 hover:scale-[1.02] disabled:opacity-60"
          >
            {saving ? "Salvando..." : "Salvar configurações"}
          </button>
          <p className="text-center text-xs text-creme/45">
            As alterações entram em vigor imediatamente na landing page.
          </p>
        </form>

        <BannersAdmin />
      </div>
    </div>
  );
}
